import type { ReactNode } from 'react'
import { CONTENT_CONTAINER } from '../../lib/layout'

export function PageWrapper({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`${CONTENT_CONTAINER} px-4 py-4 space-y-3 ${className ?? ''}`}>{children}</div>
}
